import { IconButton, Spinner } from "@carbon6/c6-frontend-design";
import { CopyIcon, LockIcon } from "@carbon6/c6-frontend-design/icons";
import type { AnnotationStudioBinding } from "./useAnnotationStudio";
import styles from "./AnnotationSetLockOverlay.module.css";

/**
 * 확정 세트를 고르면 도구 섹션 위에 이 층을 덮는다. c6 는 자리(`annotationToolsOverlay`)와
 * scrim 을 제공한다. 이 컴포넌트는 잠금 사유와 해제 방법을 한 카드에 표시한다.
 *
 * 잠긴 컨트롤을 disable 하고 사유를 화면 아래 한 줄로 표시하는 것으로는 부족하다. 사유가 잠긴
 * 도구와 멀어지면 사용자는 무엇이 도구를 잠갔는지 알 수 없다. 카드는 불투명 배경을 가진다.
 * scrim 아래 패널의 명도는 정해져 있지 않아서, 배경이 없으면 글자 대비를 보장할 수 없다.
 */
export function AnnotationSetLockOverlay({ binding }: { binding: AnnotationStudioBinding }) {
  const cloning = binding.setAction.action === "clone";

  return (
    <div className={styles.card} role="status">
      <span className={styles.heading}>
        <LockIcon aria-hidden="true" />
        읽기 전용
      </span>
      <p className={styles.body}>
        확정한 Annotation Set은 Training이 읽는 결과물이라 내용을 바꿀 수 없습니다. 새 draft로
        복제하거나, 삭제 후 다시 생성해 주세요.
      </p>
      <IconButton
        text={cloning ? "복제 중…" : "새 draft로 복제"}
        size="sm"
        variant="solid"
        disabled={binding.setAction.action !== null}
        onClick={() => void binding.cloneSelectedSet()}
      >
        {cloning ? <Spinner size="sm" /> : <CopyIcon aria-hidden="true" />}
      </IconButton>
    </div>
  );
}
